
import { NavLink, useNavigate } from 'react-router-dom';
import enviromment from '../../environment';
import './BreadCrumb.scss';

const BreadCrumb = ({ breads }) => {
    const navigate = useNavigate();

    const breadItems = breads.map(item =>
        <li key={item.url} className={`breadcrumb-item ${item.active ? 'active' : ''}`} aria-current="page" >
            {item.active ? <span>{item.name}</span> : <NavLink to={item.url}>{item.name}</NavLink>}
        </li>
    );

    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li>
                    <button className="uninter-btn-voltar" style={{ float: 'left', marginRight: 15 }} onClick={() => { navigate(-1); }}>
                        Voltar
                    </button>
                </li>
                <li className="uninter-breadcrumb-enviromement-nome">
                    <h3>
                        {enviromment.nome}
                    </h3>
                </li>
                <li className="breadcrumb-item">
                    <NavLink to="/">
                        <i className="fa fa-home">
                        </i> Início
                    </NavLink>
                </li>
                {breadItems}
            </ol>
        </nav>
    );
}

export default BreadCrumb;